import { combineReducers } from 'redux';

import auth from './reducers/auth';

export default combineReducers({
	auth,
});
